webpackJsonp([0],{

/***/ 1071:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _WebComponent2 = __webpack_require__(3);

var _WebComponent3 = _interopRequireDefault(_WebComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Ajaxing SVG sprite

var AddSvgIconSprite = function (_WebComponent) {
  _inherits(AddSvgIconSprite, _WebComponent);

  function AddSvgIconSprite() {
    _classCallCheck(this, AddSvgIconSprite);

    return _possibleConstructorReturn(this, (AddSvgIconSprite.__proto__ || Object.getPrototypeOf(AddSvgIconSprite)).apply(this, arguments));
  }

  _createClass(AddSvgIconSprite, [{
    key: 'didMount',
    value: function didMount() {
      var xhr = new XMLHttpRequest();
      var container = this.element;
      var path = container.getAttribute('data-url');

      if ('withCredentials' in xhr) {
        xhr.withCredentials;
        xhr.open('GET', path, true);
      } else if (typeof XDomainRequest != 'undefined') {
        xhr = new XDomainRequest();
        xhr.open('GET', path);
      } else {
        document.body.className += ' no-svg-sprite';
      }

      xhr.onload = function () {
        container.innerHTML = xhr.responseText;
      };

      xhr.onerror = function () {
        document.body.className += ' no-svg-sprite';
      };

      setTimeout(function () {
        xhr.send();
      }, 0);
    }
  }]);

  return AddSvgIconSprite;
}(_WebComponent3.default);

exports.default = AddSvgIconSprite;

/***/ })

});


// WEBPACK FOOTER //
// 0.js